export default __webpack_public_path__ + "static/media/rbc-logo.93b46178.svg";